export default "__VITE_ASSET__D0Lp7NeA__"